import ContainerBlockGenericTypeLogic from "../ContainersBlocks/ContainerBlockGenericTypeLogic";

function BAND({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericTypeLogic
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            userConfiguration={true}
        />
    );
}
export default BAND;